/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} one
 * @param {function} two
 * @returns {function|null}
 */

function createChainedFunction<T extends Function, U extends Function>(
  one?: T,
  two?: U
): T | U | (() => void) | undefined {
  if (one && two) {
    return function chainedFunction(this: T) {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  } else if (one) {
    return one;
  } else if (two) {
    return two;
  } else {
    return undefined;
  }
}

export default createChainedFunction;
